import React from 'react';
import { Platform, StyleSheet } from 'react-native';

import { BodyText, theme, useNavbarContainerHeight, useResponsive, VStack } from '@sg/garnish';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { useTrademark } from '../../../../../hooks/useTrademark';
import { DebugMenuTrigger } from '../../../../DebugMenu';
import { AccountMenuCrashOptions } from '../AccountMenuCrashOptions';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountMenuFooter = () => {
  const trademark = useTrademark();

  const { match } = useResponsive();
  const { paddingBottomStyle: navbarPaddingBottomStyle } = useNavbarContainerHeight();

  // ─── Flags ─────────────────────────────────────────────────────────────────

  const isCrashMenuEnabled = useFeatureFlag('permanent-order-crash-option-enabled');

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldRenderTrademark = match([Boolean(Platform.OS !== 'web' && trademark), false]);
  const shouldApplyNavbarPadding = Platform.OS !== 'web';

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [
    styles.container,
    shouldApplyNavbarPadding ? navbarPaddingBottomStyle : undefined,
  ];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <VStack testID="account-menu-footer" style={containerStyles} gap={theme.spacing['4']}>
      {shouldRenderTrademark ? <BodyText>{trademark}</BodyText> : null}
      {isCrashMenuEnabled ? <AccountMenuCrashOptions /> : null}
      <DebugMenuTrigger />
    </VStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    marginTop: theme.spacing['6'],
  },
});
